export const getOrganizationsUrl = () => '/public/organizations';

export const getUpdateOrganizationsUrl = () => '/agency/organizations';
